const isDevEnvironment = import.meta.env.VITE_ENVIRONMENT === 'DEV';
export const devComponentName = (name: string) => (isDevEnvironment ? { 'data-webcomponent': name } : {});
